module.exports = __webpack_public_path__ + "img/eth-logo-switch-highlight.aa57c965.svg";